export default "__VITE_ASSET__CeKW7npu__"